import React from 'react';
import {
  Box,
  Button,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography
} from '@mui/material';
import { SelectLocation } from '../../../common';
import FrameInventorySelector from '../../../common/FrameInventorySelector';
import SimpleDatePicker from '../../../ui/simpleDatePicker';

export default function PlaceOrderTab({
  suppliers,
  poForm,
  selectedLocationName,
  onPoFieldChange,
  onPoLineChange,
  addPoLine,
  removePoLine,
  setPoForm,
  submitPo,
  isSubmitting
}) {
  return (
    <Paper sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <TextField
            select
            fullWidth
            size="small"
            label="Supplier"
            value={poForm.supplierId}
            onChange={(e) => onPoFieldChange('supplierId', e.target.value)}
          >
            {suppliers.map(supplier => (
              <MenuItem key={supplier.id} value={supplier.id}>{supplier.supplierName}</MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} md={4}>
          <SelectLocation
            fullWidth
            location={poForm.locationId}
            setLocation={(loc) => onPoFieldChange('locationId', loc?.id || '')}
          />
        </Grid>

        <Grid item xs={12} md={4}>
          <SimpleDatePicker
            label="Expected Date"
            value={poForm.expectedDate}
            onChange={(date) => onPoFieldChange('expectedDate', date || '')}
            helperTextMode="never"
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={2}
            label="Notes"
            value={poForm.notes}
            onChange={(e) => onPoFieldChange('notes', e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle2">Line Items</Typography>
        </Grid>

        {poForm.lines.map((line, index) => (
          <Grid item xs={12} key={`po-line-${index}`}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Grid container spacing={1} alignItems="center">
                <Grid item xs={12} md={4}>
                  <FrameInventorySelector
                    label="Inventory Item"
                    value={line.inventoryItem}
                    locationId={poForm.locationId}
                    locationName={selectedLocationName}
                    onChange={(selectedItem) => {
                      setPoForm(prev => {
                        const lines = [...prev.lines];
                        lines[index] = {
                          ...lines[index],
                          inventoryItemId: selectedItem?.id || '',
                          inventoryItem: selectedItem,
                          catalogProductId: selectedItem?.catalogProductId || null
                        };
                        return { ...prev, lines };
                      });
                    }}
                    helperText={line.inventoryItemId ? '' : 'Type a model number or use search'}
                  />
                </Grid>

                <Grid item xs={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    label="Ordered Qty"
                    value={line.orderedQty}
                    onChange={(e) => onPoLineChange(index, 'orderedQty', e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    type="text"
                    inputProps={{ inputMode: 'decimal' }}
                    label="Supplier Cost"
                    value={line.unitCost}
                    onChange={(e) => onPoLineChange(index, 'unitCost', e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} md={2}>
                  <TextField
                    fullWidth
                    size="small"
                    type="text"
                    inputProps={{ inputMode: 'decimal' }}
                    label="Landing Cost"
                    value={line.landingCost}
                    onChange={(e) => onPoLineChange(index, 'landingCost', e.target.value)}
                  />
                </Grid>

                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    color="error"
                    variant="outlined"
                    onClick={() => removePoLine(index)}
                  >
                    Remove
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button variant="outlined" onClick={addPoLine}>Add Line</Button>
            <Button
              variant="contained"
              onClick={submitPo}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Saving...' : 'Create Purchase Order'}
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}